module.exports = __webpack_public_path__ + "static/media/Car_calligraphy_5.81c002bb.jpg";